import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "priyaraa_token";
export const SHOP_TOKEN_KEY = "priyaraa_customer_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Separate instance for customer (shopper) auth — keeps admin & customer tokens independent.
export const shopApi = axios.create({ baseURL: API });
shopApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(SHOP_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 1x1 transparent placeholder to avoid empty <img src> warnings.
export const IMG_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3Crect width='1' height='1' fill='%23F3EDE2'/%3E%3C/svg%3E";

// Resolve a stored image reference. Keep paths RELATIVE so they resolve against
// the current origin — absolute URLs get blanked by the preview overlay, relative ones render.
export const resolveImg = (url) => {
  if (!url) return IMG_PLACEHOLDER;
  return url;
};

// Ordered list of a product's images (falls back to legacy single image_url).
export const getImages = (p) => {
  if (p?.images?.length) return p.images;
  if (p?.image_url) return [p.image_url];
  return [];
};

export const formatPrice = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

// Selling price, strike-through original, and discount % — supports sale_price + compare_at_price.
export const priceInfo = (p) => {
  const selling = p?.sale_price || p?.price || 0;
  const strike = p?.sale_price ? p?.price : p?.compare_at_price || null;
  const discount = strike && strike > selling ? Math.round(((strike - selling) / strike) * 100) : 0;
  return { selling, strike: discount > 0 ? strike : null, discount };
};

export const inStock = (p) => (p?.stock ?? 0) > 0;

// Resolve the active logo for a given surface variant from brand settings.
export const logoFor = (settings, variant = "desktop") => {
  if (!settings) return "/priyaraa-logo.png";
  const map = {
    desktop: settings.logo_desktop, mobile: settings.logo_mobile,
    light: settings.logo_light, dark: settings.logo_dark, primary: settings.logo_primary,
  };
  return map[variant] || settings.logo_primary || "/priyaraa-logo.png";
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
